import { ProformaTemplate, ProformaTemplateService } from '../../proforma-template';
import { ProformaTemplateExpenseService } from '../../proforma-template';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import { PrimeNGConfig } from 'primeng/api';

@Component({
    selector: 'app-proforma-template',
    templateUrl: './proforma-template.component.html',
    styleUrls: ['./proforma-template.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ProformaTemplateComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private proformaTemplateService: ProformaTemplateService,
		private proformaTemplateExpenseService: ProformaTemplateExpenseService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.proformaTemplate = data.proformaTemplate,
			this.statuses = proformaTemplateService.statuses;
		this.feeTypes = proformaTemplateExpenseService.feeTypes;
		this.expenseFreqs = proformaTemplateExpenseService.expenseFreqs;
	}

	@Input() proformaTemplate: ProformaTemplate;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	proformaTemplateId: number;

	// forms
	form1: UntypedFormGroup;
	expenseForm: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;
	feeTypes: any;
	expenseFreqs: any;

	// Expenses
	expenses: any[] = [];
	editingExpenseId: number = null;

	validationMessages = {
		'templateName': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '3 characters minimum' }],
		'templateDescription': [],
		'isActive': [],
		'defaultMgmtFeePCT': [],
		'defaultInitialTermMonths': [],
		'defaultSubsequentTermMonths': [],
		'defaultFreeDepartureCleanNUM': [],
		'defaultFreeCarDaysNUM': [],
		'defaultSignCreditAMT': [],
		'defaultRemodelCreditAMT': [],
		'defaultUpgradeCredit': [],
		'defaultMgmtFeeCreditAMT': [],
		'defaultOtherCreditAMT': [],
		'propertiesMin': [],
		'propertiesMax': [],
		'propertiesDefault': [],
		'termLengthMin': [],
		'termLengthMax': [],
		'termLengthStep': [],
		'termLengthDefault': [],
		'ownerDaysMin': [],
		'ownerDaysMax': [],
		'ownerDaysDefault': [],
		'ownerCleaningsMin': [],
		'ownerCleaningsMax': [],
		'ownerCleaningsDefault': [],
		'rentalCarDaysMin': [],
		'rentalCarDaysMax': [],
		'rentalCarDaysDefault': [],
		'unitConditionDefault': [],
		'baseMgmtFeePCT': [],
		'perPropertyDiscountPCT': [],
		'perTermMonthDiscountPCT': [],
		'mgmtFeeFloorPCT': [],
		'mgmtFeeCeilingPCT': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();
		this.expenseFormBuild();

		if (this.proformaTemplate) {
			this.proformaTemplateId = this.proformaTemplate.proformaTemplateId;
			this.form1.patchValue(this.proformaTemplate);
			this.expenses = this.proformaTemplate.proformaTemplateExpenses || [];
		}
	}

	onFormDelete() {
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.proformaTemplateId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;
			this.proformaTemplateService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.proformaTemplate = res.data.proformaTemplate;
						this.proformaTemplateId = this.proformaTemplate.proformaTemplateId;
						this.doAdd.emit(this.proformaTemplate);
					},
					(err: any) => {
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		try {
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;
			this.proformaTemplateService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.proformaTemplate = res.data.proformaTemplate;
						this.doUpdate.emit(this.proformaTemplate);
					},
					(err: any) => {
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.proformaTemplateService.delete(this.proformaTemplate.proformaTemplateId)
				.subscribe(
					(res: any) => {
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.proformaTemplate);
					},
					(err: any) => {
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			proformaTemplateId: [this.proformaTemplateId],
			// Metadata
			templateName: ['', Validators.compose([Validators.minLength(3), Validators.required])],
			templateDescription: [],
			isActive: [true],
			// Default values
			defaultMgmtFeePCT: [],
			defaultInitialTermMonths: [],
			defaultSubsequentTermMonths: [],
			defaultFreeDepartureCleanNUM: [],
			defaultFreeCarDaysNUM: [],
			defaultSignCreditAMT: [],
			defaultRemodelCreditAMT: [],
			defaultUpgradeCredit: [],
			defaultMgmtFeeCreditAMT: [],
			defaultOtherCreditAMT: [],
			// Slider guardrails
			propertiesMin: [],
			propertiesMax: [],
			propertiesDefault: [],
			termLengthMin: [],
			termLengthMax: [],
			termLengthStep: [],
			termLengthDefault: [],
			ownerDaysMin: [],
			ownerDaysMax: [],
			ownerDaysDefault: [],
			ownerCleaningsMin: [],
			ownerCleaningsMax: [],
			ownerCleaningsDefault: [],
			rentalCarDaysMin: [],
			rentalCarDaysMax: [],
			rentalCarDaysDefault: [],
			unitConditionDefault: [],
			// Fee formula
			baseMgmtFeePCT: [],
			perPropertyDiscountPCT: [],
			perTermMonthDiscountPCT: [],
			mgmtFeeFloorPCT: [],
			mgmtFeeCeilingPCT: [],
		});
	}

	// Expense inline management
	expenseFormBuild() {
		this.expenseForm = this.formBuilder.group({
			proformaTemplateExpenseId: [],
			feeType: ['', Validators.required],
			name: ['', Validators.required],
			description: [],
			quantity: [1],
			expenseAmnt: [],
			expensePct: [],
			expenseFreq: [3, Validators.required],
			proformaTemplateId: [this.proformaTemplateId]
		});
	}

	addExpense() {
		this.expenseForm.markAllAsTouched();
		if (this.expenseForm.invalid) return;

		const val = { ...this.expenseForm.value, proformaTemplateId: this.proformaTemplateId };
		this.proformaTemplateExpenseService.add(val).subscribe(
			(res: any) => {
				this.expenses.push(res.data.proformaTemplateExpense);
				this.expenses = [...this.expenses];
				this.expenseFormBuild();
				this.messageService.add({ severity: 'success', summary: 'Expense added' });
			},
			(err: any) => { this.alertService.error(err); }
		);
	}

	editExpense(expense: any) {
		this.editingExpenseId = expense.proformaTemplateExpenseId;
		this.expenseForm.patchValue(expense);
	}

	updateExpense() {
		this.expenseForm.markAllAsTouched();
		if (this.expenseForm.invalid) return;

		const val = { ...this.expenseForm.value, proformaTemplateExpenseId: this.editingExpenseId, proformaTemplateId: this.proformaTemplateId };
		this.proformaTemplateExpenseService.update(val).subscribe(
			(res: any) => {
				const idx = this.expenses.findIndex(e => e.proformaTemplateExpenseId === this.editingExpenseId);
				this.expenses[idx] = res.data.proformaTemplateExpense;
				this.expenses = [...this.expenses];
				this.editingExpenseId = null;
				this.expenseFormBuild();
				this.messageService.add({ severity: 'success', summary: 'Expense updated' });
			},
			(err: any) => { this.alertService.error(err); }
		);
	}

	cancelEditExpense() {
		this.editingExpenseId = null;
		this.expenseFormBuild();
	}

	deleteExpense(expense: any) {
		this.confirmationService.confirm({
			message: 'Delete expense "' + expense.name + '"?',
			accept: () => {
				this.proformaTemplateExpenseService.delete(expense.proformaTemplateExpenseId).subscribe(
					(res: any) => {
						this.expenses = this.expenses.filter(e => e.proformaTemplateExpenseId !== expense.proformaTemplateExpenseId);
						this.messageService.add({ severity: 'success', summary: 'Expense deleted' });
					},
					(err: any) => { this.alertService.error(err); }
				);
			}
		});
	}

	getFeeTypeName(value: string): string {
		const found = this.feeTypes.find(f => f.value === value);
		return found ? found.name : value;
	}

	getFreqName(value: number): string {
		const found = this.expenseFreqs.find(f => f.value === value);
		return found ? found.name : '' + value;
	}

	toPercent(val: any) {
		if (val == null) return '';
		return (val * 100).toFixed(1) + '%';
	}

	toCurrency(val: any) {
		if (val == null) return '';
		return '$' + val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	}
}
